module.exports = __webpack_public_path__ + "img/hr-deepwater-side.f58b8aca.png";